/** @flow */
import React from "react";
import classNames from "classnames";
import "./icon-button.style.scss";

type IconButtonProps = $Exact<{
  className?: string,
  onClick?: Function,
  icon: string | React$Node,
  disabled?: boolean,
}>;

const IconButton = (props: IconButtonProps) => (
  <div
    className={classNames(
      "icon-button",
      {
        disabled: props.disabled,
      },
      props.className,
    )}
    onClick={props.onClick}
  >
    {typeof props.icon === "string" ? <img src={props.icon} alt="action" /> : props.icon}
  </div>
);

export default IconButton;
